import { useEffect, useState } from "react";

import { Assistant } from "@/commands/AIConcierge/assistant";
import {
  AssistantWrapperStyle,
  BackgroundWrapper,
  CharacterCommentArea,
  FrontImageWrapper,
} from "@/commands/AIConcierge/assistantWrapper.style";
import { ConversationNode } from "@/commands/AIConcierge/types";
import distantView from "@/public/AIConcierge/backgrounds/distantView.png";
import foregroundView from "@/public/AIConcierge/backgrounds/foreground.png";
import defaultCharacter from "@/public/AIConcierge/characters/default.gif";
import naturalCharacter from "@/public/AIConcierge/characters/natural.gif";
import pointCharacter from "@/public/AIConcierge/characters/point.gif";
import twoHandsCharacter from "@/public/AIConcierge/characters/twoHands.gif";
import guruguruComment from "@/public/AIConcierge/comment/guruguru.svg";
import kakuComment from "@/public/AIConcierge/comment/kaku.svg";
import maruComment from "@/public/AIConcierge/comment/maru.svg";
import mokumokuComment from "@/public/AIConcierge/comment/mokumoku.svg";

const CHARACTER_GIF_VARIANTS: Array<{
  pattern: ConversationNode["characterGifPattern"];
  src: string;
}> = [
  { pattern: "default", src: defaultCharacter },
  { pattern: "natural", src: naturalCharacter },
  { pattern: "point", src: pointCharacter },
  { pattern: "twoHands", src: twoHandsCharacter },
];

export function AssistantWrapper(): JSX.Element {
  const [characterPattern, setCharacterPattern] =
    useState<ConversationNode["characterGifPattern"]>("default");
  const [commentSrc, setCommentSrc] = useState(kakuComment);
  const [characterComment, setCharacterComment] =
    useState("バーチャル\nコンシェルジュです");

  const [showCharacterComment, setShowCharacterComment] = useState(true);

  // キャラクターGIFパターンに応じた切り替え関数
  const updateCharacterGif = (
    pattern: ConversationNode["characterGifPattern"],
  ) => {
    const hasPattern = CHARACTER_GIF_VARIANTS.some(
      ({ pattern: targetPattern }) => targetPattern === pattern,
    );

    setCharacterPattern(hasPattern ? pattern : "default");
  };

  // キャラクターコメント画像パターンに応じた切り替え関数
  const updateCommentImage = (
    pattern: ConversationNode["characterCommentImagePattern"],
  ) => {
    const commentMap = {
      kaku: kakuComment,
      guruguru: guruguruComment,
      maru: maruComment,
      mokumoku: mokumokuComment,
    };
    setCommentSrc(commentMap[pattern]);
  };

  // パターンに応じた更新関数
  const updateCharacterByPattern = (node: ConversationNode) => {
    updateCharacterGif(node.characterGifPattern);
    updateCommentImage(node.characterCommentImagePattern);
    setCharacterComment(node.characterComment);
  };

  const resetCharacterState = () => {
    setCharacterPattern("default");
    setCommentSrc(kakuComment);
    setCharacterComment("バーチャル\nコンシェルジュです");
  };

  useEffect(() => {
    let lastInteractionTime = Date.now();
    const handleUserInteraction = () => {
      lastInteractionTime = Date.now();
    };

    window.addEventListener("mousemove", handleUserInteraction);
    window.addEventListener("keydown", handleUserInteraction);

    const interval = setInterval(() => {
      if (Date.now() - lastInteractionTime > 300000) {
        window.location.reload();
      } else {
        handleUserInteraction();
      }
    }, 300000);

    return () => {
      clearInterval(interval);
      window.removeEventListener("mousemove", handleUserInteraction);
      window.removeEventListener("keydown", handleUserInteraction);
    };
  }, []);

  return (
    <AssistantWrapperStyle backgroundImageSrc={distantView}>
      {CHARACTER_GIF_VARIANTS.map(({ pattern, src }) => (
        <BackgroundWrapper
          key={pattern}
          src={src}
          isVisible={characterPattern === pattern}
        />
      ))}
      <FrontImageWrapper frontImageSrc={foregroundView} />
      <CharacterCommentArea
        src={commentSrc}
        style={{
          opacity: showCharacterComment ? 1 : 0,
          transition: "opacity 0.5s ease-in-out",
        }}
      >
        {characterComment.split(/\n/).map((item) => (
          <>
            {item}
            <br />
          </>
        ))}
      </CharacterCommentArea>
      <Assistant
        updateCharacterByPattern={updateCharacterByPattern}
        setShowCharacterComment={setShowCharacterComment}
        resetCharacterState={resetCharacterState}
      />
    </AssistantWrapperStyle>
  );
}
